<template>
  <Render v-if="column.columnCode === 'action'" :data="item" :render="column.value"/>
  <span v-else>{{ column.value(item) }}</span>
</template>

<script>

export default {
  name: 'TableCell',
  props: {
    column: {
      type: Object,
      required: true
    },
    item: {
      type: null,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .is-clickable {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/listing/TableCell.vue